import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import EhelpDashboardContainer from './containers/EhelpDashboardContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({
  totalStatsIncident,
  getTotalStatsIncident,
  totalStatsCovidVaccine,
  getTotalStatsCovidVaccine,
}) {
  const returnIncidentStatisticsData = () => {
    // TODO: replace data with ehelp api
    const data = _.get(
      totalStatsIncident,
      'res.data.total_incident_report_per_type'
    );

    return {
      label: 'Incident',
      total: _.get(totalStatsIncident, 'res.data.total', 0),
      // photo: ''
      list: [
        {
          label: 'Environmental Incident',
          value: _.get(data, 'Environmental Incident', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Injury to Employee or Contractor',
          value: _.get(data, 'Injury to employee or contractor', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Liability Report',
          value: _.get(data, 'Liability Report', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Others',
          value: _.get(data, 'Others', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Quality Control',
          value: _.get(data, 'Quality Control', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };
  const returnCovidVaccineStatisticData = () => {
    const data = _.get(
      totalStatsCovidVaccine,
      'res.data.total_covid_vaccine_registration_per_status'
    );

    return {
      label: 'Covid-19 Vaccine',
      total: _.get(totalStatsCovidVaccine, 'res.data.total', 0),
      // photo: ''
      list: [
        {
          label: 'Registered',
          value: _.get(data, 'not_vaccinated', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Vaccinated',
          value: _.get(data, 'vaccinated', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };
  useEffect(() => {
    getTotalStatsIncident();
    getTotalStatsCovidVaccine();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={returnIncidentStatisticsData()}
            className="mb-3"
          />
          <DashboardListCard data={returnCovidVaccineStatisticData()} />
        </div>
        <div className="col-8 pr-0">
          <EhelpDashboardContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStatsIncident: PropTypes.instanceOf(Object).isRequired,
  getTotalStatsIncident: PropTypes.instanceOf(Function).isRequired,
  totalStatsCovidVaccine: PropTypes.instanceOf(Object).isRequired,
  getTotalStatsCovidVaccine: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStatsIncident: _.get(api, `${c.GET_TOTAL_STATS_INCIDENT}`) || {},
  totalStatsCovidVaccine:
    _.get(api, `${c.GET_TOTAL_STATS_COVID_VACCINE}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
